import Topics from '../page/Community/Topics';

//Base url
export const API_BASE_URL = 'http://localhost:4000';
// export const API_BASE_URL = 'api.finzaid.com';  prod

export const URLs = {
  // Auth
  REGISTER_URL: '/api/auth/signUp',
  LOGIN_URL: '/api/auth/signIn',
  FORGOT_PASSWORD_URL: '/api/auth/forgotPassword',
  RESET_PASSWORD_URL: '/api/auth/resetPassword',
  LOGOUT_URL: '/api/auth/signOut',
  CONFIRM_CODE_VERIFY_URL: '/api/auth/confirmSignUp',
  RESEND_URL: '/api/auth/resendCode',

  CHECK_USER_VERIFIED_URL: '/api/auth/check-verified',

  JOIN_SESSION_URL: '/api/v1/registerEvents/:eventId', //post
  GET_REGISTER_SESSION_DETAILS_URL: '/api/v1/registerEvents', //get
  REGISTER_SESSION_URL: '/api/v1/registerEvents', //get
  DELETE_REGISTER_SESSION_URL: '/api/v1/registerEvents/:eventId', //post

  //Sessions
  CRAETE_SESSION_URL: '/api/v1/events', //Post
  EDIT_SESSION_URL: '/api/v1/events/:eventId', //Put
  FETCH_ALL_SESSION_URL: '/api/v1/events/', //Get
  GET_SESSION_BY_ID_URL: '/api/v1/events/:eventId', //Get
  DELETE_SESSION_BY_ID_URL: '/api/v1/events/:eventId', //Delete

  // User managamanr
  GET_ALL_USERS_URL: '/api/user/getUsers', //Get
  UPDATE_PROFILE: '/api/user/updateUser', //PUT

  //s3 multiple upload
  GENERATE_S3_VIDEO_UPLOAD_ID: '/api/v1/s3Config', //Get
  UPLOAD_S3_VIDEO: '/api/v1/s3Config', //Post
  COMPLETE_UPLOAD_S3_VIDEO: '/api/v1/s3Config', //Put

  // Event collection
  CREATE_EVENT_COLLECTION: '/api/v1/eventCollection', //Post
  GET_EVENT_COLLECTIONS: 'api/v1/eventCollection',
  GET_BY_SINGlE_COLLECTION: '/api/v1/eventCollection',
  DELETE_COLLECTION: 'api/v1/eventCollection',

  // article
  CREATE_ARTICLE: 'api/v1/articles',
  GET_ALL_ARTICLES: 'api/v1/articles',
  GET_SINGLE_ARTICLE: 'api/v1/articles',
  UPDATE_ARTICLE: 'api/v1/articles',
  DELETE_ARTICLE: 'api/v1/articles',

  // Community
  // Post
  SUMBIT_POST: 'api/v1/posts',
  GET_ALL_POST: 'api/v1/posts',
  ADD_LIKE: 'api/v1/posts',
  DELETE_POST: 'api/v1/posts',

  // comments
  ADD_COMMENTS_TO_POST: 'api/v1/comments',
  GET_ALL_COMMENTS: 'api/v1/comments',

  // topcs
  TOPICS_URL: 'api/v1/topics',

  //Signal
  MARKET_SIGNAL: 'api/v1/signals',

  //notification
  GET_NOTIFICATION: 'api/messages',
};
